// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2u-CC","popperHost":"App_popperHost__3SHPW","spinner":"App_spinner__3gMZt"};